export default __webpack_public_path__ + "assets/b2ccfb29027cc2118b3b52403e6a34a5.webp";